module.exports = __webpack_public_path__ + "images/arrowLeftfea3374567aa48ab5d4a6407588603ea.svg";